<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img
          class="img-fluid"
          src="../assets/images/banner/introduction_banner.jpg"
          alt="banner"
        />
        <div class="banner-text">
          <h1>學會簡介</h1>
          <div class="banner-text-line"></div>
          <span>Introduction</span>
        </div>
      </div>
    </div>
    <div
      class="contentContainer-noMove"
      :style="{ backgroundImage: 'url(' + BG + ')' }"
    >
      <div class="content">
        <!-- mobile 用 -->
        <div
          v-if="screenWidth < 768"
          class="accordion mb-4 mt-4"
          id="insideMenuMobile"
        >
          <div class="card">
            <div class="card-header insideMenu-header" id="headingOne">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  {{ title }}
                  <i class="fas fa-angle-down fa-lg insideMenu-icon"></i>
                  <i class="fas fa-angle-up fa-lg insideMenu-icon"></i>
                </button>
              </h2>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#insideMenuMobile"
            >
              <div>
                <div class="list-group list-bg" id="list-tab" role="tablist">
                  <a
                    v-for="(item, index) in listTitle"
                    :key="index"
                    class="list-group-item text-center"
                    :class="{ active: title === item.titleZh }"
                    :id="item.titleEn"
                    data-toggle="list"
                    role="tab"
                    :aria-controls="item.titleEn"
                    @click="setTitle(item.titleZh)"
                    >{{ item.titleZh }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PC 用 -->
        <div v-if="screenWidth >= 768" class="d-flex justify-content-center">
          <div
            class="list-group list-group-horizontal list-bg list-area rounded-pill"
            id="list-tab"
            role="tablist"
          >
            <a
              v-for="(item, index) in listTitle"
              :key="index"
              class="list-group-item text-center rounded-pill list-pointer"
              :class="{ active: title === item.titleZh }"
              :id="item.titleEn"
              data-toggle="list"
              role="tab"
              :aria-controls="item.titleEn"
              @click="setTitle(item.titleZh)"
              >{{ item.titleZh }}</a
            >
          </div>
        </div>
        <div class="tab-content" id="nav-tabContent">
          <transition-group mode="out-in">
            <!-- 學會歷史 -->
            <div v-if="title === '學會歷史'" key="transition1">
              <div class="content-title">
                <h2>學會歷史</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  學會簡介
                </div>
              </div>
              <div class="content-textBox">
                <div class="firstSection">
                  <img
                    class="img-fluid"
                    src="../assets/images/logo_big.jpg"
                    alt="logo"
                  />
                  <div class="text">
                    <h3>學會宗旨</h3>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                  </div>
                </div>
                <!-- <div class="secondSection">
                  <div class="text">
                    <h3>創建任務</h3>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。本會為依法設立、非以營利為目的之社會團體，
                      <span
                        >經由推廣及實踐口腔健康的促進和口腔疾病的預防保健</span
                      >及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                  </div>
                  <div class="text">
                    <h3>學會期許</h3>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。本會為依法設立、非以營利為目的之社會團體，
                      <span
                        >經由推廣及實踐口腔健康的促進和口腔疾病的預防保健</span
                      >及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- 學會章程 -->
            <div v-if="title === '學會章程'" key="transition2">
              <div class="content-title">
                <h2>學會章程</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  學會簡介
                </div>
              </div>
              <div class="content-textBox">
                <div class="text">
                  <div class="text-right">
                    本章程經本會111年11月27日第四屆第一次會員大會修正通過<br>
                    本章程經本會108年10月20日第二屆第二次會員大會修正通過
                    <!-- 報經內政部 年 月 日台內社字第 號函准予備查。 -->
                  </div>
                  <h3>第一章 總則</h3>
                  <tr>
                    <td>第一條</td>
                    <td>
                      <strong
                        >本會名稱為台灣口腔衛生科學學會（以下簡稱本會）。英文名稱為Taiwan
                        Academy for Dental Hygiene (簡稱為TADH)。</strong
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>第二條</td>
                    <td>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </td>
                  </tr>
                  <tr>
                    <td>第三條</td>
                    <td>
                      <strong>
                        本會之任務如下：
                        <br />一、推廣及發展口腔衛生相關科學之研究、教育。
                        <br />二、舉辦口腔衛生相關科學之學術研討、會議。
                        <br />三、研究發展口腔衛生相關科學法令及制度。
                        <br />四、出版口腔衛生相關科學之刊物、文宣。
                        <br />五、舉辦及推廣口腔衛生相關科學國際學術交流。
                        <br />六、配合政府推動上述相關之任務或業務及其他委任事項。
                        <br />七、申請或接受政府及相關團體之研究或評估事項。
                        <br />八、口腔衛生相關器材及用品的研究、開發、檢測事項。
                        <br />九、符合本會宗旨或章程所規定的相關事項。
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>第四條</td>
                    <td>
                      本會之主管機關為內政部，本會之目的事業應受各該事業主管機關之指導、監督。
                    </td>
                  </tr>
                  <tr>
                    <td>第五條</td>
                    <td>本會以全國行政區域為組織區域。</td>
                  </tr>
                  <tr>
                    <td>第六條</td>
                    <td>
                      本會會址設於主管機關所在地區，並得報經主管機關核准設分支機構。<br />
                      前項分支機構組織簡則由理事會擬訂，報請主管機關核准後行之。<br />
                      會址及分支機構之地址於設置及變更時，應函報主管機關核備。
                    </td>
                  </tr>
                </div>
                <div class="text">
                  <h3>第二章 會員、理事及監事</h3>
                  <tr>
                    <td>第七條</td>
                    <td>
                      本會會員及會費分類如下：<br />
                      一般會員
                      <tr>
                        <td class="insideTd">一、</td>
                        <td>
                          個人會員：凡贊同本會宗旨、年滿20歲、<strong>具有認同本會宗旨，並具有推動口腔衛生及健康促進經驗的相關系所人士</strong>，填具入會申請書，經理事會審查通過，並繳納會費後，為個人會員；<strong>入會費新臺幣壹仟元</strong>，於會員入會時繳納；
                        </td>
                      </tr>
                      其他會員
                      <tr>
                        <td class="insideTd">一、</td>
                        <td>
                          學生會員：以<strong>學生身分加入</strong>，為本會學生會員。
                        </td>
                      </tr>
                      <tr>
                        <td class="insideTd">二、</td>
                        <td>
                          榮譽會員：<strong>65歲以上</strong>、具有認同本會宗旨，並具有推動口腔衛生及健康促進經驗的相關系所人士；或為本會<strong>歷任理事長者</strong>，經理事會審查通過認可。免繳常年會費。
                        </td>
                      </tr>
                      <tr>
                        <td class="insideTd">三、</td>
                        <td>
                          贊助會員：凡贊同本會宗旨且贊助本會經費、資源之廠商。
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td>第八條</td>
                    <td>
                      會員（會員代表）有發言權、表決權、選舉權、被選舉權與罷免權。每一會員（會員代表）為一權。
                      其他會員除發言權外，無前項權利。
                    </td>
                  </tr>
                  <tr>
                    <td>第九條</td>
                    <td>
                      <strong
                        >本會置理事15人、候補理事3人、常務理事5人</strong
                      >，由理事互選之，並由理事就常務理事中選舉1人為副理事長及1人為理事長。<br />
                      理事長對內綜理督導會務，對外代表本會，並擔任會員大會、理監事會主席。<br />
                      理事長因事不能執行職務時，應指定副理事長代理支，理事長及副理事長未指定或不能指定時，由常務理事互推1人代理之。<br />
                      理事長、副理事長、常務理事出缺時，應於1個月內補選之。
                    </td>
                  </tr>
                  <tr>
                    <td>第十條</td>
                    <td>
                      <strong
                        >本會置監事5人、候補監事1人、常務監事1人</strong
                      ><br />監事會置常務監事，由監事互選之，監察日常會務，並擔任監事會主席。
                    </td>
                  </tr>
                  <tr>
                    <td>第十一條</td>
                    <td>
                      會員有遵守本會章程、決議及繳納會費之義務。<br />會員未繳納會費者，不得享有會員權利，連續2年未繳納會費者，視為自動退會。會員經出會、退會或停權處分，如欲申請復會或復權時，除有正當理由經理事會審核通過者外，應繳清前所積欠之會費。
                    </td>
                  </tr>
                  <tr>
                    <td>第十二條</td>
                    <td>
                      會員（會員代表）有違反法令、章程或不遵守會員大會決議時，得經理事會決議，予以警告或停權處分，其危害團體情節重大者，得經會員大會決議予以除名。
                    </td>
                  </tr>
                  <tr>
                    <td>第十三條</td>
                    <td>
                      會員有下列情事之一者，為出會：<br />
                      一、死亡。<br />
                      二、喪失會員資格者。<br />
                      三、經會員（會員代表）大會決議除名者。
                    </td>
                  </tr>
                  <tr>
                    <td>第十四條</td>
                    <td>會員得以書面敘明理由向本會聲明退會。</td>
                  </tr>
                </div>

                <div class="text">
                  <h3>第三章 組織及職權</h3>
                  <tr>
                    <td>第十五條</td>
                    <td>
                      本會以會員大會為最高權力機構。會員（會員代表）人數超過300人以上者，得分區比例選出會員代表，再合開會員代表大會，行使會員大會職權。會員代表任期與理事、監事相同，其名額及選舉辦法由理事會擬訂，報請主管機關核備後行之。
                    </td>
                  </tr>
                  <tr>
                    <td>第十六條</td>
                    <td>
                      會員（會員代表）大會之職權如下：
                      <br />一、訂定與變更章程。
                      <br />二、選舉及罷免理事、監事。
                      <br />三、議決入會費、常年會費、事業費及會員捐款之數額及方式。
                      <br />四、議決年度工作計畫、報告及預算、決算。
                      <br />五、議決會員（會員代表）之除名處分。
                      <br />六、議決財產之處分。 <br />七、議決本會之解散。
                      <br />八、議決與會員權利義務有關之其他重大事項。
                      <br />前項第八款重大事項之範圍由理事會定之。
                    </td>
                  </tr>
                  <tr>
                    <td>第十七條</td>
                    <td>
                      本會理事、監事，由會員（會員代表）選舉之，分別成立理事會、監事會。
                      <br />選舉前項理事、監事時，依計票情形得同時選出候補理事，候補監事，遇理事、監事出缺時，分別依序遞補之。
                      <br />理事會得提出下屆理事、監事候選人參考名單。
                      <br />理事、監事得採用通訊選舉。通訊選舉辦法由理事會通過，報請主管機關核備後行之。
                    </td>
                  </tr>
                  <tr>
                    <td>第十八條</td>
                    <td>
                      理事會之職權如下：
                      <br />一、審定會員（會員代表）之資格。
                      <br />二、選舉及罷免常務理事、副理事長及理事長。
                      <br />三、議決理事、常務理事、副理事長及理事長之辭職。
                      <br />四、聘免工作人員。
                      <br />五、擬訂年度工作計畫、報告及預算、決算。
                      <br />六、其他應執行事項。
                    </td>
                  </tr>
                  <tr>
                    <td>第十九條</td>
                    <td>
                      常務監事因事不能執行職務時，應指定監事1人代理之，未指定或不能指定時，由監事互推1人代理之。
                      <br />監事會主席（常務監事）出缺時，應於1個月內補選之。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十條</td>
                    <td>
                      監事會之職權如下：<br />
                      一、監察理事會工作之執行。<br />
                      二、審核年度決算。<br />
                      三、選舉及罷免常務監事。<br />
                      四、議決監事及常務監事之辭職。<br />
                      五、其他應監察事項。<br />
                    </td>
                  </tr>
                  <tr>
                    <td>第二十一條</td>
                    <td>
                      理事、監事均為無給職，任期三年，連選得連任。理事長之連任，以1次為限。理事、監事之任期自召開本屆第1次理事會之日起計算。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十二條</td>
                    <td>
                      理事、監事有下列情事之一者，應即解任：<br />
                      一、喪失會員（會員代表）資格者。<br />
                      二、因故辭職經理事會或監事會決議通過者。<br />
                      三、被罷免或撤免者。<br />
                      四、受停權處分期間逾任期二分之一者。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十三條</td>
                    <td>
                      本會置秘書長1人，承理事長之命處理本會事務，其他工作人員若干人，由理事長提名經理事會通過聘免之，並報主管機關備查。<br />
                      前項工作人員不得由理事、監事擔任。<br />
                      工作人員權責及分層負責事項由理事會另定之。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十四條</td>
                    <td>
                      本會得設各種委員會、小組或其他內部作業組織，其組織簡則經理事會通過後施行，變更時亦同。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十五條</td>
                    <td>
                      本會得由理事會聘請名譽理事長1人，顧問若干人，其聘期與理事、監事之任期同。
                    </td>
                  </tr>
                </div>
                <div class="text">
                  <h3>第四章 會議</h3>
                  <tr>
                    <td>第二十六條</td>
                    <td>
                      會員（會員代表）大會分定期會議與臨時會議2種，由理事長召集之，召集時除緊急事故之臨時會議外，應於15日前以書面通知。<br />
                      定期會議每年召開1次，臨時會議於理事會認為必要，或經會員（會員代表）五分之一以上之請求，或監事會函請召集時召開之。<br />
                      本會辦理法人登記後，臨時會議經會員（會員代表）十分之一以上之請求召開之。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十七條</td>
                    <td>
                      會員（會員代表）不能親自出席會員大會時，得以書面委託其他會員（會員代表）代理，每1會員（會員代表）以代理1人為限。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十八條</td>
                    <td>
                      會員（會員代表）大會之決議，以會員（會員代表）過半數之出席，出席人數較多數之同意行之。但下列事項之決議以出席人數三分之二以上同意行之。<br />
                      一、章程之訂定與變更。<br />
                      二、會員（會員代表）之除名。<br />
                      三、理事、監事之罷免。<br />
                      四、財產之處分。<br />
                      五、本會之解散。<br />
                      六、其他與會員權利義務有關之重大事項。<br />
                      本會辦理法人登記後，章程之變更以出席人數四分之三以上之同意或全體會員三分之二以上書面之同意行之。<br />
                      本會之解散，得隨時以全體會員三分之二以上之可決議解散之。
                    </td>
                  </tr>
                  <tr>
                    <td>第二十九條</td>
                    <td>
                      理事會每3個月至少舉行會議1次，監事會每3個月至少舉行會議1次，必要時得召開聯席會議或臨時會議。<br />
                      前項會議召集時除臨時會議外，應於7日前以書面通知，會議之決議，各以理事、監事過半數之出席，出席人數較多數之同意行之。
                    </td>
                  </tr>
                  <tr>
                    <td>第三十條</td>
                    <td>
                      理事應出席理事會議，監事應出席監事會議，理事會、監事會不得委託出席；理事、監事連續2次無故缺席理事會、監事會者，視同辭職。
                    </td>
                  </tr>
                </div>
                <div class="text">
                  <h3>第五章 經費及會計</h3>
                  <tr>
                    <td>第三十一條</td>
                    <td>
                      本會經費來源如下：<br />
                      一、入會費：個人會員：新台幣壹仟元、學生會員：新台幣伍佰元，於會員入會繳納。<br />
                      二、常年會費：個人會員：新台幣壹仟元、學生會員：新台幣伍佰元。<br />
                      三、事業費。<br />
                      四、會員捐款。<br />
                      五、委託收益。<br />
                      六、基金及其孳息。<br />
                      七、其他收入。
                    </td>
                  </tr>
                  <tr>
                    <td>第三十二條</td>
                    <td>
                      本會會計年度以曆年為準，自每年1月1日起至12月31日止。<br />
                      本會每年於會計年度開始前2個月，由理事會編造年度工作計畫、收支預算表、員工待遇表，提會員大會通過（會員大會因故未能如期召開者，先提理監事聯席會議通過），於會計年度開始前報主管機關核備。並於會計年度終了後2個月內，由理事會編造年度工作報告、收支決算表、現金出納表、資產負債表、財產目錄及基金收支表，送監事會審核後，造具審核意見書送還理事會，提會員大會通過，於3月底前報主管機關核備（會員大會未能如期召開，先經理事監事聯席會議通過後，再報主管機關）。
                    </td>
                  </tr>
                  <tr>
                    <td>第三十三條</td>
                    <td>
                      本會於解散後，剩餘財產歸屬所在地之地方自治團體或主管機關指定之機關團體所有。
                      本會解散之清算程序，如經法人登記者，除法律另有規定外，依民法之規定辦理；如未經法人登記者，應依章程或會員
                      (會員代表) 大會決議辦理，章程未規定或會員 (會員代表)
                      大會無法召開時，由主管機關選任清算人，並準用民法清算之規定辦理。
                    </td>
                  </tr>
                </div>
                <div class="text">
                  <h3>第六章 附則</h3>
                  <tr>
                    <td>第三十四條</td>
                    <td>本章程未規定事項，悉依有關法令規定辦理。</td>
                  </tr>
                  <tr>
                    <td>第三十五條</td>
                    <td>
                      本章程經會員（會員代表）大會通過，報經主管機關核備後施行，變更時亦同。
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>第三十七條</td>
                    <td>
                      本章程經本會 年 月 日第一屆第一次會員大會通過 報經內政部
                      年 月 日台內社字第 號函准予備查。
                    </td>
                  </tr> -->
                </div>
              </div>
            </div>
            <!-- 理事長的話 -->
            <div v-if="title === '理事長的話'" key="transition3">
              <div class="content-title">
                <h2>理事長的話</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  學會簡介
                </div>
              </div>
              <div class="content-textBox">
                <div class="firstSection">
                  <img
                    class="img-fluid presidentPic"
                    src="../assets/images/president-2.jpg"
                    alt="理事長照片"
                  />
                  <div class="text">
                    <h3>各位會員，大家好</h3>
                    <p>
                      台灣口腔衛生科學學會於民國94年12月17-18日成立於高雄醫學大學(以下簡稱高醫大)，由擔任高醫大口腔衛生學系系主任黃純德教授發起，以高醫大、台北醫學大學(簡稱北醫大)、中國醫藥大學口腔衛生學系的教授們、高醫大口腔衛生科學研究所碩士班及碩士在職專班學生為主，再加上北醫大口腔衛生學系在職專班部分畢業生、及一些熱心於口腔衛生教育與推廣的他院校老師們。
                    </p>
                    <p>
                      在牙科領域中口腔保健專業人員包括牙醫師(Dentist)、口腔衛生師（Dental hygienists）、牙醫助理(Dental assistant)與牙體技術師（Dental technicians）。我國於2003年口腔健康法之立法，本意在於「促進及維護國民口腔健康」因而訂定此特別法，且法條中明訂「政府應推行口腔疾病預防及保健工作」並且應指定專責人員、設置專責單位，辦理有關口腔健康業務。衛福部並於民國102年設立「心理及口腔健康司」，為回應民眾需求及專業發展趨勢，心理健康及口腔健康司於民國111年五月四日正式分家，成立口腔健康司。
                    </p>
                    <p>
                      台灣目前在口腔健康維持與照護，多以治療為導向，而能提供預防導向的專業照護人力仍大量缺乏，眼見我國已進入高齡社會，亟需長期照護的人力投入。現在已有八所以上的大學、科大或專科校設有口腔衛生學系(科)，未來期待有更多學校能加入我們的行列，充實口腔照護人力。專業醫護人力之持續性教育訓練，口腔保健專業團隊之建立、與其他跨專業職種等長照人力的整合與訓練，提升全人照護品質，強化國民的口腔健康素養、口腔健康及生活品質，是未來重要任務，亦是學會的最大宗旨。
                    </p>
                  </div>
                </div>
                <div class="secondSection">
                  <!-- <div class="text">
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。本會為依法設立、非以營利為目的之社會團體，
                      <span
                        >經由推廣及實踐口腔健康的促進和口腔疾病的預防保健</span
                      >及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                  </div>
                  <div class="text">
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。本會為依法設立、非以營利為目的之社會團體，
                      <span
                        >經由推廣及實踐口腔健康的促進和口腔疾病的預防保健</span
                      >及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                    <p>
                      本會為依法設立、非以營利為目的之社會團體，經由推廣及實踐口腔健康的促進和口腔疾病的預防保健及加強大眾對口腔衛生知識及健康的認知來進行口腔衛生相關議題的研究、
                      推廣及評估，以提昇國民口腔健康及生活品質為宗旨。
                    </p>
                  </div> -->
                </div>
                <div class="signature">
                  <div class="signature-img">
                    <p>理事長</p>
                    <!-- <img
                      src="../assets/images/signature.jpg"
                      alt="理事長簽名"
                    /> -->
                    <span>黃曉靈</span>
                  </div>
                  <!-- <span>110年3月26日</span> -->
                </div>
              </div>
            </div>
            <!-- 理事監名錄 -->
            <div v-if="title === '理事監名錄'" key="transition4">
              <div class="content-title">
                <h2>理事監名錄</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  理事監名錄
                </div>
              </div>
              <div class="supervisory">
                <div class="supervisory-btnBlock">
                  <template v-for="(item, index) in lists">
                    <button
                      v-if="index === 0"
                      class="btn btn-supervisory active"
                      :key="'btnBlock' + index"
                      @click="setSupervisory(index)"
                      :data-id="index"
                    >
                      {{
                        item.title.replace("台灣口腔衛生科學學會理監事", "")
                      }}({{ item.date }})
                    </button>
                    <button
                      v-else
                      class="btn btn-supervisory"
                      :key="'btnBlock' + index"
                      @click="setSupervisory(index)"
                      :data-id="index"
                    >
                      {{
                        item.title.replace("台灣口腔衛生科學學會理監事", "")
                      }}({{ item.date }})
                    </button>
                  </template>
                </div>
                <div class="supervisory-textBlock">
                  <div class="supervisory-textBlock-title">
                    <h3>
                      {{ setList.title }}
                      <span>({{ setList.date }})</span>
                    </h3>
                  </div>
                  <div class="supervisory-textBlock-table">
                    <table>
                      <tr v-for="(item, index) in setList.table" :key="index">
                        <td class="table-underline table-title">
                          {{ item.title }}
                        </td>
                        <td class="table-space"></td>
                        <td class="table-underline">
                          <p v-for="(i, index) in item.content" :key="index">
                            {{ i }}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
            <!-- 講師介紹 -->
            <div v-if="title === '講師介紹'" key="transition6">
              <div class="content-title">
                <h2>講師介紹</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  學會簡介
                </div>
              </div>
              <div class="content-textBox">
                <div class="firstSection">
                  <img
                    class="img-fluid presidentPic"
                    src="../assets/images/lecturer.jpg"
                    alt="講師照片"
                  />
                  <div class="text">
                    <h3>講師 李梅冠</h3>
                    <p>學經歷</p>
                    <p>
                      高雄醫學大學口腔衛生科學研究所碩士
                    </p>
                    <p>
                      教育部部定講師
                    </p>
                    <p>
                      台北醫學大學講師
                    </p>
                    <p>
                      耕莘健康管理專科學校口照科講師
                    </p>
                    <p>
                      教育部國教署學童口腔計畫輔導委員
                    </p>
                  </div>
                </div>
                <div class="secondSection">
                </div>
              </div>
            </div>
            <!-- 組織架構 -->
            <div v-if="title === '組織架構'" key="transition5">
              <div class="content-title">
                <h2>組織架構</h2>
                <div class="bread">
                  <router-link to="/">
                    <i class="fas fa-home fa-lg"></i>
                  </router-link>
                  <span>></span>
                  組織架構
                </div>
              </div>
              <div class="text-center">
                <img
                  class="img-fluid"
                  src="../assets/images/architecture-1.jpg"
                  alt="組織架構圖"
                />
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Introduction',
  data() {
    return {
      BG,
      // screenWidth: 0,
      title: '學會歷史',
      nowIndex: 0,
      lists: [
        {
          title: '第四屆台灣口腔衛生科學學會理監事',
          date: '111.11~114.11',
          table: [
            {
              title: '理事長',
              content: ['黃曉靈'],
            },
            {
              title: '副理事長',
              content: ['林穎志'],
            },
            {
              title: '常務理事/理事',
              content: [
                '常務理事 : 何佩珊、謝宗明、李恆',
                '理事: 洪文綺、黃詠愷、吳如惠、郭念愉、董國龍、王文岑、藍文謙、陳立昇、呂國勳、汪硯雲',
              ],
            },
            {
              title: '常務監事/監事',
              content: [
                '常務監事 : 林佩蓁',
                '監事: 李梅冠、林子賢、周幸華、劉秀月',
              ],
            },
            {
              title: '秘書長',
              content: ['林宜靜'],
            },
            {
              title: '學術委員會主委',
              content: ['何佩珊'],
            },
            {
              title: '口衛推廣含國際交流委員會主委',
              content: ['黃詠愷'],
            },
            {
              title: '資訊出版委員會主委',
              content: ['董國龍'],
            },
            {
              title: '財務委員會主委',
              content: ['謝宗明'],
            },
            {
              title: '法制委員會主委',
              content: ['李恆'],
            },
          ],
        },
        {
          title: '第三屆台灣口腔衛生科學學會理監事',
          date: '108.10~111.10',
          table: [
            {
              title: '理事長',
              content: ['黃純德'],
            },
            {
              title: '常務理事/理事',
              content: [
                '常務理事 : 黃曉靈、陳立昇、藍文謙、邱耀章',
                '理事: 何佩珊、黃詠愷、謝宗明、林子賢、洪文綺、黎達明、林穎志、陳志章、涂筱培、馮茂倉',
              ],
            },
            {
              title: '常務監事/監事',
              content: [
                '常務監事 : 林佩蓁',
                '監事: 李梅冠、王文岑、張進順、郭念愉',
              ],
            },
            {
              title: '秘書長',
              content: ['林宜靜'],
            },
            {
              title: '教育委員會主委',
              content: ['黃曉靈'],
            },
            {
              title: '學術委員會主委',
              content: ['何佩珊'],
            },
            {
              title: '口衛推廣委員會主委',
              content: ['馮茂倉'],
            },
            {
              title: '資訊出版委員會主委',
              content: ['謝宗明'],
            },
            {
              title: '會員資格審查委員會主委',
              content: ['林佩蓁'],
            },
            {
              title: '公關暨會員推廣委員會主委',
              content: ['黃詠愷'],
            },
            {
              title: '會員福利委員會主委',
              content: ['李梅冠'],
            },
            {
              title: '國際(含大陸)委員會主委',
              content: ['邱思瑜'],
            },
            {
              title: '財務委員會主委',
              content: ['劉秀月'],
            },
            {
              title: '社會服務委員會主委',
              content: ['邱耀章'],
            },
            {
              title: '法制委員會主委',
              content: ['陳志章'],
            },
            {
              title: '會員擴展委員會主委',
              content: ['藍文謙'],
            },
          ],
        },
      ],
      listTitle: [
        {
          titleZh: '學會歷史',
          titleEn: 'history',
        },
        {
          titleZh: '學會章程',
          titleEn: 'constitution',
        },
        {
          titleZh: '理事長的話',
          titleEn: 'messages',
        },
        {
          titleZh: '理事監名錄',
          titleEn: 'supervisory',
        },
        {
          titleZh: '講師介紹',
          titleEn: 'lecturer',
        },
        {
          titleZh: '組織架構',
          titleEn: 'architecture',
        },
      ],
    };
  },
  methods: {
    setTitle(text) {
      const vm = this;
      vm.title = text;
      $('#collapseOne').collapse('hide');
    },
    setSupervisory(index) {
      const vm = this;
      $('.btn-supervisory').removeClass('active');
      // eslint-disable-next-line no-restricted-globals
      $(event.target).addClass('active');
      // eslint-disable-next-line no-restricted-globals
      // console.log(event.target.getAttribute('data-id'), index, event.target);
      vm.nowIndex = index;
    },
  },
  created() {
    const vm = this;
    if (vm.$route.params.data) {
      vm.title = vm.$route.params.data;
    }
    // this.screenWidth = window.innerWidth;
    // $('#collapseOne').collapse('hide');
  },
  computed: {
    setList() {
      const vm = this;
      return vm.lists[vm.nowIndex];
    },
    screenWidth() {
      return this.$store.state.screenWidth;
    },
  },
};
</script>
